import { render } from "./TaskBostonNaming.vue?vue&type=template&id=430d5d6f"
import script from "./TaskBostonNaming.vue?vue&type=script&lang=js"
export * from "./TaskBostonNaming.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__